var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_love_outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_love_outline-2",
    "data-name": "Icon_love_outline",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.5,10a.551.551,0,0,1-.392-.165L.914,5.54A3.271,3.271,0,0,1,3.272,0,2.487,2.487,0,0,1,4.911.733a5.835,5.835,0,0,1,.589.62,5.839,5.839,0,0,1,.589-.62A2.487,2.487,0,0,1,7.728,0a3.271,3.271,0,0,1,2.28,5.619L5.892,9.835A.543.543,0,0,1,5.5,10ZM3.272,1.111A2.169,2.169,0,0,0,1.1,3.272a2.147,2.147,0,0,0,.6,1.493l3.8,3.89L9.23,4.833l.011-.011A2.138,2.138,0,0,0,9.9,3.272,2.169,2.169,0,0,0,7.728,1.111a1.461,1.461,0,0,0-.909.453,5.969,5.969,0,0,0-.87,1.023.547.547,0,0,1-.9,0,5.987,5.987,0,0,0-.87-1.023A1.461,1.461,0,0,0,3.272,1.111Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.c5f443246ed8a6993474a006a255f83d.svg";
export { ForwardRef as ReactComponent };